// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"Oqc-v","rc-tabs-tab-active":"jD5t3","input-suffix":"emfH7","nav-item":"ymSt6","location-info-card":"ohfa5","location-info":"_8uQ7L","hours":"ABYuk"};